import css from "./style.module.css";
import React, { useState, useEffect } from "react";
import { fetchData, sendStatusData } from "../../api";
import Pagination from "../applications/pagination";
const ManageRequests = () => {
  const [allData, setAllData] = useState([]); // Состояние для заявок

  // Загрузка данных при загрузке компонента
  useEffect(() => {
    loadData();
  }, []);

  // Функция для загрузки данных
  const loadData = async () => {
    try {
      const response = await fetchData();
      if (response.success) {
        setAllData(response.data);
      } else {
        console.error("Ошибка при загрузке данных:", response.message);
        alert("Ошибка при загрузке данных.");
      }
    } catch (error) {
      console.error("Ошибка при подключении к серверу:", error);
      alert("Ошибка при подключении к серверу.");
    }
  };

  // Функция для обновления статуса
  const updateStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "В работе" ? "Выполнено" : "В работе";
    // const statusStyle = newStatus === "Выполнено" ? "green" : "red";
    const response = await sendStatusData({
      id,
      status: newStatus,
    });

    if (response.success) {
      // Обновляем статус локально после успешного ответа
      setAllData((prevData) =>
        prevData.map((data) =>
          data.id === id ? { ...data, status: newStatus } : data
        )
      );
    }
  };

  const [currentPage, setCurrentPage] = useState(1); // текущая страница пагинации

  const itemsPerPage = 10; // количество заявок на странице
  const totalPages = Math.ceil(allData.length / itemsPerPage);
  const reversedData = [...allData].reverse(); // Переворачиваем данные
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = reversedData.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <main className={css["root"]}>
      <div className="container">
        <h1 className={css["title"]}>Управление заявками</h1>
        {/* Пагинация */}
        <div className={css.pagination}>
          <Pagination totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
        <ul className={css.application_list}>
          {currentItems.map((data) => (
            <li key={data.id} className={css["application-item"]}>
              <div className={css["requestCard"]}>
                <div className={css.requestCard__content}>
                  <h2>Заявка</h2>
                  <h3>
                    <span className={css.request_item}>Номер заявки: </span>
                    {data.id}
                  </h3>
                  <p>
                    <span className={css.request_item}>ФИО учителя: </span>
                    {data.name}
                  </p>
                  <p>
                    <span className={css.request_item}>Номер телефона: </span>
                    {data.number}
                  </p>
                  <p>
                    <span className={css.request_item}>Кабинет: </span>
                    {data.cabinet}
                  </p>
                  <p>
                    <span className={css.request_item}>
                      Дата и время написания:{" "}
                    </span>
                    {new Date(data.date).toLocaleString("ru-RU", {
                      timeZone: "Asia/Sakhalin",
                    })}
                  </p>
                  <p>
                    <span className={css.request_item}>Проблема: </span>
                    <i>{data.problem}</i>
                  </p>
                  <div className={css["applications-status"]}>
                    <p>
                      Статус:{" "}
                      {data.status === "В работе" ? (
                        <span
                          className={css["status"]}
                          style={{ background: "rgb(219, 72, 72)" }}
                        >
                          В работе
                        </span>
                      ) : (
                        <span
                          className={css["status"]}
                          style={{ background: "rgb(61, 167, 61)" }}
                        >
                          Выполнено
                        </span>
                      )}
                      {/* <span className={css["status"]}>{data.status}</span> */}
                    </p>
                    <button
                      className={css["status-btn"]}
                      onClick={() => updateStatus(data.id, data.status)}
                    >
                      Изменить статус
                    </button>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
};

export default ManageRequests;
